import PremiumIcon from "assets/images/components/PremiumIcon";
import ContentBox from "components/ContentBox";
import Table from "components/Table";
import TitleSection from "components/TitleSection";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getLifeCycle } from "utils/api";

const TablesLifeCycle = () => {
  const { t } = useTranslation();
  const columns = [
    { label: t("tables.life-cycle.type"), accessor: "lifecycle_type" },
    { label: t("tables.life-cycle.years_until_retirement"), accessor: "years_till_pensionage" },
    { label: t("tables.life-cycle.percentage_equity"), accessor: "percentage_equity", format: "PERCENTAGE" },
  ];
  const [lifeCycle, setLifeCycle] = useState();
  useEffect(() => { getLifeCycle().then(t => setLifeCycle(t)) }, [])
  return (
    <ContentBox>
      <TitleSection title={t("tables.life-cycle.title")} Icon={PremiumIcon} />
      {lifeCycle && <Table data={lifeCycle} columns={columns} />}
    </ContentBox>
  );
};

export default TablesLifeCycle;
